import './index.css';
import { Juris } from 'juris/juris';
import { HeadlessManager } from 'juris/juris-headless';
import { LoginBox } from './pages/login.js';
import { PlayerHome } from './pages/player-home.js';
import { TopBanner } from './ui/top-banner.js';
import { GameCell } from './ui/game-cell.js';
import { AuthService } from './services/auth-service.js';
import { Conditional } from './ui/conditional.js';
import { GameLinkService } from './services/game-link.js';

const App = (props, { Auth }) => {
  return {
    render: () => ({
      Conditional: {
        condition: () => Auth.isLoggedIn(),
        then: { PlayerHome: {} },
        else: { LoginBox: {} },
      },
    }),
  };
};

const juris = new Juris({
  features: {
    headless: HeadlessManager,
  },
  logLevel: 'error',
  components: { App, LoginBox, PlayerHome, TopBanner, GameCell, Conditional },
  headlessComponents: {
    Auth: { fn: AuthService, options: { autoInit: true } },
    GameLink: { fn: GameLinkService, options: { autoInit: true } },
  },

  layout: {
    App: {},
  },

  states: {},
});

// Render the app
juris.render('#app');

// Global access for debugging
window.juris = juris;
